export const CLEAR_ERROR = 'clear-checkout-error';
const clearError = () => ({ type: CLEAR_ERROR });
export default clearError;
